import { ButtonTriggerEvent } from '../';

export class CreateTripModalActions {
    confirm: (tripTitle: string, event: ButtonTriggerEvent) => void;
    cancel?: () => void;

}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/create.trip.modal/create.trip.modal.provider.ts